import { IRootState } from "../../../redux/rootReducer";

export const spendingDemandMapState = (state: IRootState) => ({
    spendingDemand: state.spendingDemand,
})